/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Upload_Error_SizeInputs */

const en_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File is too large. Maximum size is 3 MB.`)
};

const de_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei ist zu gross. Maximale Groesse ist 3 MB.`)
};

const fr_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier est trop volumineux. Taille maximale : 3 Mo.`)
};

const es_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo es demasiado grande. El tamano maximo es 3 MB.`)
};

const it_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file e troppo grande. Dimensione massima: 3 MB.`)
};

const nl_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bestand is te groot. Maximale grootte is 3 MB.`)
};

const pl_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plik jest za duzy. Maksymalny rozmiar to 3 MB.`)
};

const fi_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedosto on liian suuri. Enimmäiskoko on 3 Mt.`)
};

const da_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filen er for stor. Maksimal storrelse er 3 MB.`)
};

const sv_onboarding_upload_error_size = /** @type {(inputs: Onboarding_Upload_Error_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filen ar for stor. Maximal storlek ar 3 MB.`)
};

/**
* | output |
* | --- |
* | "File is too large. Maximum size is 3 MB." |
*
* @param {Onboarding_Upload_Error_SizeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_upload_error_size = /** @type {((inputs?: Onboarding_Upload_Error_SizeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Upload_Error_SizeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_upload_error_size(inputs)
	if (locale === "fr") return fr_onboarding_upload_error_size(inputs)
	if (locale === "es") return es_onboarding_upload_error_size(inputs)
	if (locale === "it") return it_onboarding_upload_error_size(inputs)
	if (locale === "nl") return nl_onboarding_upload_error_size(inputs)
	if (locale === "pl") return pl_onboarding_upload_error_size(inputs)
	if (locale === "fi") return fi_onboarding_upload_error_size(inputs)
	if (locale === "da") return da_onboarding_upload_error_size(inputs)
	if (locale === "sv") return sv_onboarding_upload_error_size(inputs)
	return en_onboarding_upload_error_size(inputs)
});